<!-- NOSONAR: click on wrapper div is a passive UX helper (resets float label), not an interactive control. No keyboard handler needed. -->
<div class="login" (click)="floatLabel = 'auto'">
  <div nxLayout="grid nogutters" class="login-layout">
    <div nxRow class="login-row">
      <div nxCol="12,12,12,7">
        <div class="login__image-block background-img">
          <div class="login__image-block-heading">
            <div class="login__image-block-logo">
              <img src="assets/images/shared/Logo - White.svg" />
            </div>
            <h1 class="nx-font-weight-semibold login-heading">
              {{ "LOGIN.TITLE" | translate }}
            </h1>
            <h1
              class="nx-font-weight-semibold login-heading"
              [attr.aria-label]="'LOGIN.TITLE_WITH_BRAND' | translate"
              [innerHTML]="'LOGIN.TITLE_WITH_BRAND' | translate"
            ></h1>
            <h2 class="nx-font-weight-regular subfont-padding-top">
              {{ "LOGIN.SUBTITLE_1" | translate }}
            </h2>
            <h2 class="nx-font-weight-regular">
              {{ "LOGIN.SUBTITLE_2" | translate }}
            </h2>
          </div>
        </div>
      </div>

      <div nxCol="12,12,12,5" class="login__forms">
        <div class="login__branch">
          <nx-link>
            <a
              class="allianz-link-font allianz-link"
              href="https://www.allianz.com.my"
              target="_blank"
              >{{ "LOGIN.ALLIANZ_MALAYSIA" | translate }}</a
            >
          </nx-link>
        </div>

        <div class="std-flex-wrapper y-center--">
          <div class="login__forms-wrapper mobile-padding-login">
            <nx-message
              nxFormfieldNote
              *ngIf="(concurrentLoginError$ | async)?.isConcurrentLogin"
            >
              <div class="left-float">
                <nx-icon size="s" name="info-circle" color="primary"></nx-icon>
              </div>
              <div class="maintainance-info-desc">
                <strong
                  >{{
                    (concurrentLoginError$ | async)?.concurrentLoginErrorInfo
                  }}
                </strong>
                <div>
                  <span
                    >{{
                      (concurrentLoginError$ | async)?.concurrentLoginErrorMsg
                    }}
                  </span>
                </div>
              </div>
            </nx-message>
            <nx-message
              *ngIf="(alertMsg$ | async) && (loginError$ | async) == null"
              nxFormfieldNote
            >
              <div class="left-float">
                <nx-icon size="s" name="info-circle" color="primary"></nx-icon>
              </div>
              <div class="maintainance-info-desc">
                <strong>{{ "LOGIN.SCHEDULED_MAINTENANCE" | translate }}</strong>
                <div>
                  <span>{{ alertMsg$ | async }} </span>
                </div>
              </div>
            </nx-message>

            <nx-error
              nxFormfieldError
              *ngIf="
                (loginError$ | async) && (isUserSessionActive$ | async) == false
              "
            >
              <strong class="error-title"> {{ loginError$ | async }}</strong>
              <div *ngIf="getErrorDesc$ | async">
                <span> {{ getErrorDesc$ | async }}</span>
              </div>
            </nx-error>

            <!--
              Autocomplete is intentionally enabled here so Chrome/Edge can save
              and auto-fill this login page. The sibling reset/change-password pages already ship
              password inputs with no autocomplete guard.
            -->
            <form [formGroup]="loginForm" #loginFormVC (ngSubmit)="onLogin()">
              <nx-formfield [label]="'LOGIN.FORM.USER_ID' | translate">
                <input
                  nxInput
                  type="text"
                  formControlName="userId"
                  name="userId"
                  id="userId"
                  autocomplete="username"
                />
                <nx-icon
                  class="info-circle-o"
                  nxFormfieldAppendix
                  nxPopoverDirection="top"
                  nxPopoverTrigger="hover"
                  [nxPopoverTriggerFor]="popoverLogIn"
                >
                </nx-icon>
                <nx-popover #popoverLogIn>
                  <span
                    class="pop-over pop-over-font"
                    [innerHTML]="'LOGIN.FORM.FIRST_TIME_USER_INFO' | translate"
                  >
                  </span>
                </nx-popover>
                <nx-error appearance="text" nxFormfieldError>
                  {{ "LOGIN.FORM.USER_ID_REQUIRED" | translate }}
                </nx-error>
              </nx-formfield>

              <nx-formfield [label]="'LOGIN.FORM.PASSWORD' | translate">
                <input
                  nxInput
                  #password
                  formControlName="password"
                  type="password"
                  name="password"
                  id="password"
                  autocomplete="current-password"
                />
                <nx-password-toggle
                  [control]="password"
                  #NxPwTouchToggle
                  [appPasswordTouchToggle]="NxPwTouchToggle"
                  [ariaLabel]="'LOGIN.FORM.SHOW_PASSWORD' | translate"
                  nxFormfieldSuffix
                >
                </nx-password-toggle>

                <nx-error
                  appearance="text"
                  nxFormfieldError
                  *ngIf="loginForm.controls['password'].errors?.['required']"
                >
                  {{ "LOGIN.FORM.PASSWORD_REQUIRED" | translate }}
                </nx-error>
                <nx-error
                  appearance="text"
                  nxFormfieldError
                  *ngIf="loginForm.controls['password'].errors?.['minlength']"
                >
                  {{
                    "LOGIN.FORM.PASSWORD_MIN_LENGTH"
                      | translate: { min: passwordMinLength }
                  }}
                </nx-error>
              </nx-formfield>

              <nx-link nxStyle="block">
                <a (click)="navigateToResetPassword()" style="cursor: pointer">
                  <nx-icon name="arrow-right"></nx-icon>
                  {{ "LOGIN.FORM.FORGOT_PASSWORD" | translate }}
                </a>
              </nx-link>
              <button
                type="submit"
                nxButton="block primary"
                size="medium"
                class="nx-margin-top-4m std-mg-bottom-m"
              >
                {{ "LOGIN.FORM.LOGIN_BUTTON" | translate }}
              </button>
            </form>

            <div class="std-ta-center">
              <span class="need-help-label"
                >{{ "LOGIN.FORM.NEED_HELP" | translate }}
              </span>
              <nx-link>
                <a class="ie" (click)="toggleTtHelpdesk()">
                  {{ "LOGIN.FORM.IT_HELPDESK" | translate }}
                </a>
              </nx-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
